export const RETRIEVE_PRODUCTS = 'commercial/products/retrieve';
export const RETRIEVE_PRODUCT = 'commercial/products/getById';
